module.exports = __webpack_public_path__ + "static/app/img/case_item_bg3.6bd737c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/case_item_bg3.jpg
// module id = 0VXt
// module chunks = 1